import React from "react";
import { Outlet } from "react-router-dom";
import { WarningBox } from "@/components/ui/WarningBox";

function PartnersOutlet() {
    return (
        <div className="mt-28 p-6 flex flex-col gap-6 max-w-5xl mx-auto w-full">
            <WarningBox>
                <strong>Warning:</strong> This section manages partner API credentials. Misconfiguration can grant or revoke third-party access to sensitive data. Only make changes if you understand the implications.
            </WarningBox>
            <Outlet />
        </div>
    );
}

export default PartnersOutlet;
